export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  date: string; // ISO
  readTime: string;
  image: string;
  category: string;
}

const BANNER = 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/485ee0f5-162d-499f-b44f-69bc80fbabf9/1785626036737-vd8ge.png';
const HANDI = 'https://storage.googleapis.com/happyspace-generated-images/generated/2026-08-01/8a8598f2b264.png';

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: 'biryani-restaurant-near-me-omaha-dine-in-takeout-delivery',
    title: 'Biryani Restaurant Near Me — Dine-In, Takeout & Delivery in Omaha',
    excerpt:
      'Find the best biryani restaurant near you in Omaha & Council Bluffs. Biryani2Go offers authentic dum-cooked biryani for dine-in, takeout, and delivery. Order online now.',
    date: '2026-05-20',
    readTime: '9 min read',
    image: HANDI,
    category: 'Restaurant Guide',
  },
  {
    slug: 'indian-breakfast-near-me',
    title: 'Indian Breakfast, Done Right: A Morning Guide from Biryani2Go',
    excerpt:
      "Craving a real Indian breakfast? Here's what makes South and North Indian morning food different from a quick coffee-and-toast — and what to order at Biryani2Go to start your day the dum-cooked way.",
    date: '2026-05-10',
    readTime: '6 min read',
    image: HANDI,
    category: 'Breakfast',
  },
  {
    slug: 'best-biryani-in-omaha',
    title: 'Best Biryani in Omaha — Where to Find Real Dum-Cooked Biryani',
    excerpt:
      'Looking for real dum-cooked biryani in Omaha? Most restaurants serve fast biryani. Here\'s why slow-sealed, hand-layered biryani tastes completely different — and where to get it.',
    date: '2026-05-15',
    readTime: '8 min read',
    image: HANDI,
    category: 'Biryani Guide',
  },
  {
    slug: 'order-biryani-delivery-takeout-omaha',
    title: 'Order Biryani Delivery & Takeout Now — Restaurant Near Me Open',
    excerpt:
      'Need Indian food near you right now? Biryani2Go serves real dum-cooked biryani, dosas, samosas for pickup or delivery across Omaha & Council Bluffs.',
    date: '2026-05-16',
    readTime: '7 min read',
    image: HANDI,
    category: 'Ordering Guide',
  },
  {
    slug: 'what-to-order-indian-restaurant-first-timer',
    title: 'What to Order at an Indian Restaurant — First-Timer\'s Guide',
    excerpt:
      'New to Indian food? Learn the difference between biryani, samosa, dosa, and more — and what makes each dish unique. Plus, what to try first at Biryani2Go.',
    date: '2026-05-18',
    readTime: '7 min read',
    image: HANDI,
    category: 'Beginner\'s Guide',
  },
];

export function getPostBySlug(slug: string) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}

export { BANNER as BLOG_FALLBACK_IMAGE };
